import api from '../../utils/api';
import { getApiUrl } from '../../utils/config';

// Get categories for a specific store (public view)
export const getStoreCategories = async (storeSlug) => {
  try {
    const response = await api.get(getApiUrl(`/stores/${storeSlug}/categories`));
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Create a new category for a store (admin only)
export const createCategory = async (storeSlug, categoryData) => {
  try {
    // For FormData (file uploads), remove Content-Type to let browser set it
    const config = {
      headers: {
        'Content-Type': undefined,
      },
    };
    const response = await api.post(getApiUrl(`/stores/${storeSlug}/categories`), categoryData, config);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Update an existing category (admin only)
export const updateCategory = async (categoryId, categoryData) => {
  try {
    // For FormData (file uploads), remove Content-Type to let browser set it
    const config = {
      headers: {
        'Content-Type': undefined,
      },
    };
    
    // Add _method field to FormData to indicate PUT request
    categoryData.append('_method', 'PUT');
    
    const response = await api.post(getApiUrl(`/categories/${categoryId}`), categoryData, config);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Delete a category (admin only)
export const deleteCategory = async (categoryId) => {
  try {
    const response = await api.delete(getApiUrl(`/categories/${categoryId}`));
    return response.data;
  } catch (error) {
    throw error;
  }
}; 